import { Star, Award } from 'lucide-react';

interface HeroSocialProofProps {
  variant?: 'stats' | 'quote' | 'compact';
  className?: string;
}

export function HeroSocialProof({ variant = 'compact', className = '' }: HeroSocialProofProps) {
  const stats = [
    { icon: Award, value: '14', label: 'International Exhibitions' },
    { icon: Award, value: '5.0', label: 'Star Rating' },
  ];

  // Compact version for hero - just the key trust indicators
  if (variant === 'compact') {
    return (
      <div className={`${className}`}>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap sm:gap-4">
          {/* Star Rating */}
          <div className="ethereal-badge w-full max-w-[17rem] sm:w-auto">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 text-primary fill-primary" />
              ))}
            </div>
            <span className="text-sm text-foreground/95">5.0 Rating</span>
          </div>
          
          {/* Exhibitions */}
          <div className="ethereal-badge w-full max-w-[17rem] sm:w-auto">
            <Award className="h-4 w-4 text-primary" />
            <span className="text-sm text-foreground/95">14 International Exhibitions</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${className}`}>
      {variant === 'stats' && (
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mb-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex items-center gap-2 text-foreground/80"
            >
              <stat.icon className="h-4 w-4 text-primary" />
              <span className="font-serif text-lg">{stat.value}</span>
              <span className="text-sm">{stat.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
